import { useHistory } from "@cadenza/history-react";

export const useModelHistory = (initialState) => useHistory(initialState);
